module.exports = __webpack_public_path__ + "assets/roboto-v20-latin-700.eot?6231689c19f95508f99f6d965b530938";